import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import ImageCard, { ImageCardProps } from '@/components/base/ImageCard'
import Motion from '@/components/base/Motion'

import { imageCardGridRevealAnimation } from './animations'
import { Section } from '@/types'

type ImageCardGridProps = Section & {
  post_type?: string
  collection?: ImageCardProps[]
}

const ImageCardGrid = ({
  post_type,
  collection,
  ...props
}: ImageCardGridProps) => {
  return (
    <Motion animation={imageCardGridRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-sm md:gap-y-md">
              {collection?.map((card) => (
                <div
                  key={`image-card-${card.uuid}`}
                  className="col-span-2 md:col-span-3 lg:col-span-4"
                >
                  <ImageCard post_type={post_type} {...card} />
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default ImageCardGrid
